const EmailActionTypes = {
  TOGGLE_EMAIL_OVERLAY_VISIBLE: "TOGGLE_EMAIL_OVERLAY_VISIBLE",
  SET_EMAIL_OPTIONS: "SET_EMAIL_OPTIONS",
  SEND_EMAIL: "SEND_EMAIL",
  SEND_EMAIL_SUCCESS: "SEND_EMAIL_SUCCESS",
  SEND_EMAIL_FAILURE: "SEND_EMAIL_FAILURE"
};
export default EmailActionTypes;
